

/// <reference path="ProxyPaymentInstallment.ts" />

// Generated class AdyenProxyPaymentInstallment_ManagedObject

class AdyenProxyPaymentInstallment_ManagedObject extends ProxyPaymentInstallment
{

    // Property: businessID
    set businessID(value:string) {
        this.setValueForKey(value, 'businessID');
    }
    get businessID():string {
        return this.valueForKey('businessID');
    }
    set businessIDPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'businessID');
    }
    get businessIDPrimitiveValue():string {
        return this.primitiveValueForKey('businessID');
    }

    // Property: sessionID
    set sessionID(value:string) {
        this.setValueForKey(value, 'sessionID');
    }
    get sessionID():string {
        return this.valueForKey('sessionID');
    }
    set sessionIDPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'sessionID');
    }
    get sessionIDPrimitiveValue():string {
        return this.primitiveValueForKey('sessionID');
    }
}
